import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { PROJECTS } from '../../lib/site';
import { SectionHeading } from '../ui/SectionHeading';
import { BeforeAfter } from './BeforeAfter';
import { Reveal } from '../fx/Reveal';
export function ProjectGallery({
  showSlider = true
}: {
  showSlider?: boolean;
}) {
  return <section className="relative mx-auto max-w-7xl px-6 py-24" data-id="element-293" data-mp="1enb29i8dn8o6">
      <SectionHeading eyebrow="Recent Work" title="Restorations That Feel Better Than New" subtitle="A glimpse of the homes we've brought back to life across the Houston area." data-id="element-294" data-mp="2bcsigr4zkd44" />

      {showSlider && <Reveal className="mx-auto mt-14 max-w-3xl" data-id="element-295" data-mp="22aati4xy56df">
          <BeforeAfter before={PROJECTS[0].image} after={PROJECTS[1].image} label="Drag to reveal · Water Damage Restoration" data-id="element-296" data-mp="1xcrhlboq15on" />
        </Reveal>}

      <div className="mt-8 grid gap-6 sm:grid-cols-2 lg:grid-cols-4" data-id="element-297" data-mp="lxm194vo38mk">
        {PROJECTS.map((p, i) => <motion.div key={p.title} initial={{
        opacity: 0,
        y: 40,
        filter: 'blur(10px)'
      }} whileInView={{
        opacity: 1,
        y: 0,
        filter: 'blur(0px)'
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.7,
        delay: i % 4 * 0.08,
        ease: [0.22, 1, 0.36, 1]
      }} className={`group relative overflow-hidden rounded-[2rem] shadow-glass ${i % 3 === 0 ? 'sm:row-span-1' : ''}`} data-cursor="image" data-id="element-298" data-mp="26et7geh8wjjc" data-mpi={i}>
            <div className="relative aspect-[4/3] overflow-hidden" data-id="element-299" data-mp="1iofl94lcdewo">
              <img src={p.image} alt={p.title} loading="lazy" decoding="async" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-300" data-mp="1imkzjo28xirj" />
              {/* light sweep */}
              <span className="pointer-events-none absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/40 to-transparent transition-transform duration-700 group-hover:translate-x-full" data-id="element-301" data-mp="pnz9ipbrka40" />
              <div className="absolute inset-0 bg-gradient-to-t from-navy/60 via-transparent to-transparent opacity-0 transition-opacity duration-500 group-hover:opacity-100" data-id="element-302" data-mp="axib7eufe0bc" />
            </div>
            <div className="glass-strong absolute inset-x-3 bottom-3 translate-y-3 rounded-2xl px-4 py-3 opacity-0 transition-all duration-500 group-hover:translate-y-0 group-hover:opacity-100" data-id="element-303" data-mp="13lxmbqafryhe">
              <p className="text-xs font-semibold uppercase tracking-wider text-royal" data-id="element-304" data-mp="tnrnjhjxf8gr">
                {p.category}
              </p>
              <p className="font-display text-sm font-bold text-navy" data-id="element-305" data-mp="3je4r29ldyz0i">
                {p.title}
              </p>
            </div>
          </motion.div>)}
      </div>
    </section>;
}